module.exports = __webpack_public_path__ + "media/images/core_values/reliability-6b463e5811986459b18c770d21e18579.png";